<h1 mat-dialog-title>
  <span>{{ 'k003116' | translate }}</span>
  <div mat-button (click)="goOut()" class="btoCLoseModal"><span>×</span></div>
</h1>
<div mat-dialog-content>
  <img
    src="./assets/img/{{ customTheme }}/consulta.png"
    class="img-consulta"
    alt=""
  />
  <p [innerHTML]="'k003117' | translate"></p>
</div>
<div mat-dialog-actions>
  <button class="buttonPortal mb-3 ml-2" mat-button (click)="goToRetake()">
    {{ 'k003118' | translate }}
  </button>
</div>
